import { Dialog } from "primereact/dialog";
import React, { useEffect, useState } from "react";
import SuccessModal from "../../SuccessModal";
import { Button } from "primereact/button";
import { customerAddressCreate } from "../../../services/CustomerInfo/EditCustomer";
import { InputText } from "primereact/inputtext";

const EditCustomerLocationModal = ({
  setEditCustomerCurrentLocationModalVisible,
  editCustomerCurrentLocationModalVisible,
  editCurrentLocation,
  editLatitude,
  editLongitude,
  editCustomerData,
  addressEditIcon,
  storeCustomerId,
  sendDataToEditCustomer,
}) => {
  const [currentLocation, setCurrentLocation] = useState(editCurrentLocation);
  const [currentLocationLatitude, setCurrentLocationLatitude] =
    useState(editLatitude);
  const [currentLocationLongitude, setCurrentLocationLongitude] =
    useState(editLongitude);
  const [focusedField, setFocusedField] = useState("");

  const [latitudeError, setLatitudeError] = useState("");
  const [longitudeError, setLongitudeError] = useState("");

  const handleFocus = (field) => {
    setFocusedField(field);
  };

  const handleBlur = () => {
    setFocusedField("");
  };

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");

  const isValidLatitude = (latitude) => {
    return latitude >= 6.554607 && latitude <= 35.674545;
  };

  const isValidLongitude = (longitude) => {
    return longitude >= 68.111378 && longitude <= 97.395561;
  };

  const handleCurrentLocation = (text) => {
    setCurrentLocation(text);
  };
  const handleCurrentLocationLatitude = (text) => {
    const latitude = parseFloat(text);
    setCurrentLocationLatitude(text);
    if (text === "" || isValidLatitude(latitude)) {
      setLatitudeError("");
      if (currentLocationLongitude === "") {
        setLongitudeError("Longitude is Required");
      }
    } else {
      setLatitudeError("Latitude must be between 6.554607 and 35.674545.");
    }
  };

  const handleCurrentLocationLongitude = (text) => {
    const longitude = parseFloat(text);
    setCurrentLocationLongitude(text);
    if (text === "" || isValidLongitude(longitude)) {
      setLongitudeError("");
      if (currentLocationLatitude === "") {
        setLatitudeError("Latitude is Required");
      }
    } else {
      setLongitudeError("Longitude must be between 68.111378 and 97.395561.");
    }
  };

  const storeId = editCustomerData?.storeId;

  const handleEditData = async () => {
    // Update the specific field in addressItems

    // if (!isValidLatitude(parseFloat(currentLocationLatitude))) {
    //   Alert.alert(
    //     'Invalid Latitude',
    //     'Latitude must be between 6.554607 and 35.674545.',
    //   );
    //   return;
    // }

    // if (!isValidLongitude(parseFloat(currentLocationLongitude))) {
    //   Alert.alert(
    //     'Invalid Longitude',
    //     'Longitude must be between 68.111378 and 97.395561.',
    //   );
    //   return;
    // }

    if (currentLocationLongitude === "" && currentLocationLatitude === "") {
      setLongitudeError("");
      setLatitudeError("");
    }

    if (latitudeError || longitudeError) {
      // If there are validation errors, do not proceed
      return;
    }

    let restAddress = editCustomerData.address;
    let updatedData = { ...restAddress };

    updatedData.currentLocation = currentLocation.trim();
    updatedData.latitude = currentLocationLatitude.trim();
    updatedData.longitude = currentLocationLongitude.trim();

    // Add more conditions for other fields
    try {
      const response = await customerAddressCreate(
        storeCustomerId,
        storeId,
        updatedData
      );
      if (!response.data.error) {
        const Res = response.data;
        const message = Res.message;
        const status = Res.status;
        // Close the modal
        setEditCustomerCurrentLocationModalVisible(false);
        sendDataToEditCustomer({
          success: true,
        });
        if (status === true) {
          setModalVisible(true);
          setModalStatus("success");
          setModalText(message);
        } else {
          setModalVisible(true);
          setModalStatus("not Success");
          setModalText(message);
        }
        // if (Res) {
        //   sendDataToEditCustomer({
        //     success: true,
        //   });
        // }
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    //   // When the editAddressFieldName or fieldNameValue changes, update the editValue
    if (editCurrentLocation !== null) {
      setCurrentLocation(editCurrentLocation);
    }
    if (editLatitude !== null) {
      setCurrentLocationLatitude(editLatitude.toString());
    }
    if (editLongitude !== null) {
      setCurrentLocationLongitude(editLongitude.toString());
    }
  }, [editCurrentLocation, editLatitude, editLongitude]);

  const handleModalClose = () => {
    setEditCustomerCurrentLocationModalVisible(false);
    // setEditValue
    // setEditLastNameValue
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={editCustomerCurrentLocationModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!editCustomerCurrentLocationModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <i
                className="pi pi-map-marker"
                style={{ fontSize: "30px", color: "#fff" }}
              ></i>
              <p className=" text-4xl text-primary-50 font-semibold">
                Edit Location
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>

            <div className="inline-flex flex-column mx-4">
              <InputText
                value={currentLocation}
                onChange={(e) => handleCurrentLocation(e.target.value)}
                id="firstName"
                label="firstName"
                placeholder="Current Location"
                className="bg-white-alpha-20 border-round-xl p-2 text-lg"
              ></InputText>
            </div>

            <div className="flex justify-content-center align-items-center gap-2">
              <p className=" text-xl font-medium">
                ---- OR ----
              </p>
            </div>

            <div className="inline-flex flex-column mx-4">
              <InputText
                value={currentLocationLatitude}
                onChange={(e) => handleCurrentLocationLatitude(e.target.value)}
                id="firstName"
                label="firstName"
                placeholder="Latitude"
                 className="bg-white-alpha-20 border-round-xl p-2 text-lg"
              ></InputText>
            </div>

            {latitudeError ? (
              <p className=" text-lg  font-normal">{latitudeError}</p>
            ) : null}

            <div className="inline-flex flex-column mx-4">
              <InputText
                value={currentLocationLongitude}
                onChange={(e) => handleCurrentLocationLongitude(e.target.value)}
                id="firstName"
                label="firstName"
                placeholder="Longitude"
                 className="bg-white-alpha-20 border-round-xl p-2 text-lg"
              ></InputText>
            </div>

            <div style={{ marginBottom: 15 }}>
              {longitudeError ? (
                <p className=" text-lg  font-normal">{longitudeError}</p>
              ) : null}
            </div>

            
              <Button
                onClick={handleEditData}                
                className="mt-1 mb-3 mx-4 border-round-xl "
              >
                <p className=" w-full text-2xl  font-semibold flex justify-content-center">
                  Submit
                </p></Button>
            
          </div>
        )}
      ></Dialog>
      <div>
        <SuccessModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          status={modalStatus}
          text={modalText}
        />
      </div>
    </div>
  );
};

export default EditCustomerLocationModal;
